

























import Vue from 'vue'

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: (): [] => [],
    },
  },
  data: () => ({
    dialog: false,
  }),
  watch: {
    show(newVal) {
      this.dialog = newVal
    },
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    },
    submit() {
      this.$emit('submit')
      this.close()
    },
  },
})
